<template lang="pug">
  .input
    .input__icons
      .input__icon
        icon(icon-name='upload')
    input.transparent(
      type="file"
      :name="name"
      :accept="accept"
      ref="input"
      @change="onChange"
    )
    .input__el(v-html="info || `Выберите файл до&nbsp;${maxSize}&nbsp;МБ...`")
    .input__icons
      .input__icon.input__icon-err
        icon(icon-name='exclamation-circle-s')
      .input__icon.input__icon-valid
        icon(icon-name='check-bold')
    .input__border
</template>

<script>
export default {
  name: 'InputFile',
  props: {
    name: String,
    maxSize: {
      type: Number,
      default: 5
    },
    accept: {
      type: String,
      default: 'image/png, image/jpeg, image/jpg'
    },
    text: String
  },
  data () {
    return {
      file: null,
      sizeError: false,
      formatError: false
    }
  },
  computed: {
    info () {
      if (!this.file) {
        return this.text || null
      }

      let size = this.file.size
      const mb = size / 1000000
      const kb = size / 1000

      size = mb > 1 ? +mb.toFixed(1) + '&nbsp;МБ' : +kb.toFixed(1) + '&nbsp;КБ'
      return this.file.name + ' (' + size + ')'
    },
    fileName () {
      if (!this.file) {
        return null
      }
      return this.file.name
    },
    hasError () {
      return this.formatError || this.sizeError
    }
  },
  methods: {
    onChange (e) {
      if (e && e.target.files.length) {
        this.file = e.target.files[0]
        this.formatError = this.file && !(this.file.type && this.accept.indexOf(this.file.type) !== -1)
        this.sizeError = this.file ? this.file.size / 1000000 > this.maxSize : false

        const file = this.hasError ? null : e
        this.$emit('change', file)
      }
    },
    open () {
      this.$refs.input.click()
    },
    getImage () {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()

        if (!this.file) {
          resolve(null)
        }

        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(this.file)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .input {

    &__el {
      line-height: 40px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    z-index: 2;
  }
</style>
